import { Link } from "react-router-dom";
import { bookLists } from "@/mocks/manga";

export default function BooklistSection() {
  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <p className="text-xs font-bold tracking-wide text-secondary-600">BOOK LISTS</p>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">编辑精选书单</h2>
            <p className="mt-2 text-sm text-foreground-600">按主题为你整理好漫，照着追就对了</p>
          </div>
          <Link to="/booklist" className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-secondary-700 hover:text-secondary-800">
            全部书单 <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {bookLists.map((bl) => (
            <Link
              key={bl.id}
              to="/booklist"
              className={`group relative overflow-hidden rounded-2xl p-5 transition-transform hover:-translate-y-1 ${
                bl.color === "primary"
                  ? "bg-primary-500 text-background-50"
                  : bl.color === "accent"
                  ? "bg-accent-500 text-background-50"
                  : "bg-secondary-500 text-background-50"
              }`}
            >
              <i className="ri-book-2-line absolute -right-4 -top-4 text-7xl opacity-20" aria-hidden="true"></i>
              <span className="rounded-full bg-background-50/20 px-3 py-1 text-xs">
                {bl.count} 部作品
              </span>
              <h3 className="mt-6 font-heading text-xl">{bl.title}</h3>
              <p className="mt-1 text-sm text-background-50/90">{bl.subtitle}</p>
              <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-background-50/80">{bl.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium opacity-90 group-hover:opacity-100">
                查看书单 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}